import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../lib/auth'

export default function ProtectedRoute({ children }) {
  const { user, loading, initialized, sessionExpired } = useAuthStore()

  if (!initialized || loading) {
    return (
      <div className="min-h-screen bg-[#0a0e17] flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    )
  }

  if (sessionExpired) {
    return <Navigate to="/login" replace />
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return children
}
